import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Menu, MenuItem } from '@mui/material';
import * as React from 'react';
import { LocationLanguageContext } from '../contexts/LocationLanguageContext';
import { globalColors } from '../styles/globalColorVariables';
import { LocationLanguageContextType } from '../typings';
import { getAllSupportedLanguages } from '../utils/getAllSupportedLanguages';
import NvdButton from './Button';

export const LanguageSwitcher: React.FC<{}> = () => {
  const [langAnchorEl, setLangAnchorEl] = React.useState<null | HTMLElement>(null);
  const locationLanguage = React.useContext<LocationLanguageContextType | null>(LocationLanguageContext);

  const handleLangMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setLangAnchorEl(event.currentTarget);
  };
  const handleLangMenuClose = () => {
    setLangAnchorEl(null);
  };
  const setLanguage = (lang: any) => {
    locationLanguage?.updateLanguage(lang.locale);
    setLangAnchorEl(null);
  };

  const allLanguages = getAllSupportedLanguages();

  const label = allLanguages.find((x) => x.locale === locationLanguage?.language)?.displayName ?? '';

  return (
    <div>
      <NvdButton
        variant='outlined'
        onClick={handleLangMenuClick}
        label={label}
        sx={{ color: globalColors.whiteColor, borderColor: globalColors.whiteColor }}
        endIcon={<ExpandMoreIcon />}
      />
      <Menu
        anchorEl={langAnchorEl}
        keepMounted
        open={Boolean(langAnchorEl)}
        onClose={handleLangMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        {allLanguages.map((eachLang) => (
          <MenuItem key={eachLang.locale} onClick={() => setLanguage(eachLang)}>
            {eachLang.displayName}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default LanguageSwitcher;
